// extracted by mini-css-extract-plugin
export default {"wrapper":"DragEndDropFile_wrapper__Mdp+F"};